import { Controller } from "@hotwired/stimulus"

// Debounced search-as-you-type. Each keystroke resets a timer; when it fires the
// form submits into its target Turbo Frame, so only the result list re-renders.
// Enter still submits immediately (native form behavior).
export default class extends Controller {
  static targets = ["form", "input"]

  disconnect() {
    clearTimeout(this.timer)
  }

  submit() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.formTarget.requestSubmit(), 250)
  }

  // The "Clear search" link navigates the frame via its own href; we only reset
  // the input so it doesn't keep showing the abandoned query.
  clear() {
    clearTimeout(this.timer)
    this.inputTarget.value = ""
  }
}
